import {
  GET_THEME,
  CHANGE_THEME,
  TOGGLE_MENU,
  CHANGE_MENU_ACTIVE,
  GET_MAX_HEIGHT_EXPANDED,
  SET_MAX_HEIGHT_EXPANDED
} from "./types";

export const getTheme = () => {
  return {
    type: GET_THEME
  };
};

export const changeTheme = theme => {
  localStorage.setItem("theme", theme);

  return {
    type: CHANGE_THEME,
    payload: theme
  };
};

export const toggleMenu = () => {
  return {
    type: TOGGLE_MENU
  };
};

export const changeMenu = active => {
  return {
    type: CHANGE_MENU_ACTIVE,
    payload: active
  };
};

export const getMaxHeightExpanded = () => {
  return {
    type: GET_MAX_HEIGHT_EXPANDED
  };
};
export const setMaxHeightExpanded = height => {
  return {
    type: SET_MAX_HEIGHT_EXPANDED,
    payload: height
  };
};
